















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CSelect from '@/components/base/select/CSelect.vue';
@Component({
    components: {CSelect, CNumberField, CCheckbox},
})
export default class EquipmentTableSpecificRow extends Vue {
    @Prop() data: any;
    @Prop() equipmentType: any;
    @Prop() editing!: boolean;

    @Watch('equipmentType')
    onChange(value: any, old: any) {
        if (value.Use !== old.Use) this.data.Use = value.Use;
    }
}
